import { Pagination } from 'baseui/pagination'
import React, { useState } from 'react'
import { CustomTableProps, Table } from './Table'

interface TableWithPaginationProps {
    tableProps: CustomTableProps
}

const ITEMS_PER_PAGE = 10

export const TableWithPagination: React.FC<TableWithPaginationProps> = ({ tableProps }) => {
    const [currentPage, setCurrentPage] = useState(1)

    const paginatedData = tableProps.data.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE)
    const totalPages = Math.ceil(tableProps.data.length / ITEMS_PER_PAGE)

    return (
        <div>
            <Table {...tableProps} data={paginatedData} />
            <br />
            {totalPages > 1 && (
                <Pagination
                    overrides={{
                        NextButton: {
                            style: () => {
                                return { ':hover': { color: 'white' } }
                            }
                        },
                        PrevButton: {
                            style: () => {
                                return { ':hover': { color: 'white' } }
                            }
                        },
                        Select: {
                            props: {
                                overrides: {
                                    Root: {
                                        style: () => {
                                            return { ':hover': { color: 'white' } }
                                        }
                                    }
                                }
                            }
                        }
                    }}
                    size="mini"
                    currentPage={currentPage}
                    numPages={totalPages}
                    onPageChange={({ nextPage }) => setCurrentPage(nextPage)}
                />
            )}
        </div>
    )
}
